import {Component, inject} from '@angular/core';
import {DcpOrder} from '@app/model/order/dcp-order.model';
import {OrderConfirmationPageService} from '@app/services/order/order-confirmation-page.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'dcp-order-confirmation-order-info',
  templateUrl: './order-confirmation-order-info.component.html',
})
export class OrderConfirmationOrderInfoComponent {
  orderConfirmationPageService = inject(OrderConfirmationPageService)
  order$: Observable<DcpOrder> = this.orderConfirmationPageService.getOrderDetails$();
}
